module.exports = "<TextField label=\"outerStyle\" outerStyle={{transform: 'rotate(45deg)'}} />\n"